module.exports = __webpack_public_path__ + "img/scenario-bob.f82a4304.png";